import React from "react";
import Header from "./components/Header";
import Body from "./components/Body";
import Footer from "./components/Footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Lawyers from "./pages/Lawyers";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import AdminDashboard from "./pages/dashboard/AdminDashboard";
import LawyerDashboard from "./pages/dashboard/LawyerDashboard";
import ClientDashboard from "./pages/dashboard/ClientDashboard";
import ManageUsers from "./pages/admin/ManageUsers";
import ConnectWithClients from "./pages/lawyers/ConnectWithClients";
import ConnectWithLawyers from "./pages/clients/ConnectWithLawyers";
import ConnectWithLawyer from "./pages/ConnectWithLawyer";
import ConnectWithClient from "./pages/ConnectWithClient";
import RequestDetails from "./pages/RequestDetails";

import Clients from "./pages/Clients";
import Contact from "./pages/Contact";

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <Routes>
          <Route path="/" element={<Body />} />
          <Route path="/lawyers" element={<Lawyers />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/lawyer/dashboard" element={<LawyerDashboard />} />
          <Route path="/client/dashboard" element={<ClientDashboard />} />
          <Route path="/admin/manage-users" element={<ManageUsers />} />
          <Route path="/lawyer/connect" element={<ConnectWithClients />} />
          <Route path="/connect-client" element={<ConnectWithClient />} />
          <Route path="/client/connect" element={<ConnectWithLawyers />} />
          <Route path="/connect-lawyer" element={<ConnectWithLawyer />} />
          <Route path="/requests/:id" element={<RequestDetails />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;